import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clienteAxios from "../helpers/axios.helper";
import Swal from "sweetalert2";

const ServicioABM = () => {
  const location = useLocation();
  const servicioEnEdicion = location.state?.servicio || null;
  const modoEdicion = location.state?.modoEdicion || false;
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [preciopeso, setPrecioPeso] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [anexo1, setAnexo1] = useState("");
  const [anexo2, setAnexo2] = useState("");
  const [anexo3, setAnexo3] = useState("");
  const [anexo4, setAnexo4] = useState("");
  const [anexo5, setAnexo5] = useState("");
  const [imagen, setImagen] = useState(null);
  
  // Cargar datos iniciales si estamos en modo edición
  useEffect(() => {
    if (modoEdicion && servicioEnEdicion) {
      setNombre(servicioEnEdicion.nombre || "");
      setDescripcion(servicioEnEdicion.descripcion || "");
      setPrecioPeso(servicioEnEdicion.preciopeso || "");
      setImagen(servicioEnEdicion.imagen || null);
      setCategoriaSeleccionada(servicioEnEdicion.categoriaServicio_id || null);
      setAnexo1(servicioEnEdicion.anexo1 || null);
      setAnexo2(servicioEnEdicion.anexo2 || null);
      setAnexo3(servicioEnEdicion.anexo3 || null);
      setAnexo4(servicioEnEdicion.anexo4 || null);
      setAnexo5(servicioEnEdicion.anexo5 || null);
      setImagen(servicioEnEdicion.imagen || null);
    }
  }, [modoEdicion, servicioEnEdicion]);
  
  // Cargar categorías desde la API
  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        const respuesta = await clienteAxios.get("/categorias_servicios");
        setCategorias(respuesta.data);
      } catch (error) {
        console.error("Error al cargar las categorías:", error);
        Swal.fire({
          icon: "error",
          title: "Error al cargar las categorías",
          text: "Hubo un problema al cargar las categorías. Por favor, intenta más tarde.",
        });
      }
    };
    
    cargarCategorias();
  }, []);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!imagen) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona una imagen para el producto.",
      });
      return;
    }
    
    // Validar que todas las categorías estén seleccionadas
    if (!modoEdicion && !categoriaSeleccionada) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona la categoría.",
      });
      return;
    }
    
    const servicioData = {
      nombre,
      descripcion,
      preciopeso: parseFloat(preciopeso),
      categoriaServicio_id: parseInt(categoriaSeleccionada)|| servicioEnEdicion.categoriaServicio_id,
      imagen,
      anexo1,
      anexo2,
      anexo3,
      anexo4,
      anexo5,
    };
    
    try {
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        },
      });
      if (modoEdicion) {
         const response = await clienteAxios.put(`/servicios/${servicioEnEdicion.id}`, servicioData,{
          headers: { "Content-Type": "multipart/form-data" },
         });
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Servicio actualizado",
            text: "El servicio se actualizó con éxito.",
          });
          setTimeout(() => {
            navigate('/panel_administracion')
            // Código que se ejecutará después de 1 segundo
          }, 1000);
        }
      } else {
        const formData = new FormData();
        Object.entries(servicioData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        
        const response = await clienteAxios.post("/servicios", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 200) {
          Swal.close(); // Cerrar el mensaje de carga
          Swal.fire({
            icon: "success",
            title: "Servicio creado",
            text: "El servicio fue creado con éxito.",
          });
          setTimeout(() => {
            navigate('/panel_administracion')
            // Código que se ejecutará después de 1 segundo
          }, 1000);
        }
      }
    } catch (error) {
      if (error.response) {
        // Manejo específico de errores con status 400
        if (error.response.status === 400) {
          Swal.close(); // Cerrar el mensaje de carga
          const errorMessage = error.response.data.error;
          Swal.fire({
            icon: "error",
            title: "Error al subir el archivo",
            text: errorMessage || "Ocurrió un error inesperado al subir la imagen.",
          });
          return;
        }
      }
      Swal.close(); // Cerrar el mensaje de carga
      // Mensaje genérico para cualquier otro error no capturado
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al guardar el servicio. Por favor, inténtalo nuevamente.",
      });
    }
  }
  
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white border-2 border-GrisOscuro my-10 rounded-md">
    <h1 className="text-2xl font-bold mb-4">
    {modoEdicion ? "Editar Servicio" : "Nuevo Servicio"}
    </h1>
    
    <form onSubmit={handleSubmit}>
    {/* Nombre */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Nombre</label>
    <input
    type="text"
    className="w-full p-2 border rounded-md"
    value={nombre}
    onChange={(e) => setNombre(e.target.value)}
    required
    />
    </div>
    
    {/* Descripción */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Descripción</label>
    <textarea
    className="w-full p-2 border rounded-md"
    value={descripcion}
    onChange={(e) => setDescripcion(e.target.value)}
    rows="4"
    required
    ></textarea>
    </div>
    
    {/* Precio */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Precio</label>
    <input
    type="number"
    className="w-full p-2 border rounded-md"
    value={preciopeso}
    onChange={(e) => setPrecioPeso(e.target.value)}
    required
    />
    </div>
    
    {/* Imagen */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Imagen</label>
    <input
    type="file"
    className="w-full p-2 border rounded-md"
    onChange={(e) => setImagen(e.target.files[0])}
    accept="image/*"
    />
    </div>
    
    {/* Categoría */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Categoría</label>
    <select
    className="w-full p-2 border rounded-md"
    value={categoriaSeleccionada}
    onChange={(e) => setCategoriaSeleccionada(e.target.value)}
    required
    >
    <option value="">Seleccione una categoría</option>
    {categorias.map((categoria) => (
      <option key={categoria.id} value={categoria.id}>
      {categoria.titulo}
      </option>
    ))}
    </select>
    </div>
    
    {/* Anexos */}
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Anexos</label>
    <input
    type="text"
    className="w-full p-2 border rounded-md mb-2"
    value={anexo1}
    onChange={(e) => setAnexo1(e.target.value)}
    placeholder="Anexo 1"
    />
    <input
    type="text"
    className="w-full p-2 border rounded-md mb-2"
    value={anexo2}
    onChange={(e) => setAnexo2(e.target.value)}
    placeholder="Anexo 2"
    />
    <input
    type="text"
    className="w-full p-2 border rounded-md mb-2"
    value={anexo3}
    onChange={(e) => setAnexo3(e.target.value)}
    placeholder="Anexo 3"
    />
    <input
    type="text"
    className="w-full p-2 border rounded-md mb-2"
    value={anexo4}
    onChange={(e) => setAnexo4(e.target.value)}
    placeholder="Anexo 4"
    />
    <input
    type="text"
    className="w-full p-2 border rounded-md"
    value={anexo5}
    onChange={(e) => setAnexo5(e.target.value)}
    placeholder="Anexo 5"
    />
    </div>
    
    {/* Botón */}
    <div className="mt-6">
    <button
    type="submit"
    className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
    >
    {modoEdicion ? "Guardar Cambios" : "Crear Servicio"}
    </button>
    </div>
    </form>
    </div>
  );
};

export default ServicioABM;
